/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { APIErrorV2 } from '../model';
// @ts-ignore
import { APISuccessEmpty } from '../model';
// @ts-ignore
import { BnplOrderSortType } from '../model';
// @ts-ignore
import { CancelOrderDashboardRequest } from '../model';
// @ts-ignore
import { GetGeneralOrderDetail200Response } from '../model';
// @ts-ignore
import { GetOrderDetailForMPDashboard200Response } from '../model';
// @ts-ignore
import { GetOrderRequirementDocConsumer200Response } from '../model';
// @ts-ignore
import { GetOrdersList200Response } from '../model';
// @ts-ignore
import { OrderStatusType } from '../model';
// @ts-ignore
import { SortOrderType } from '../model';
// @ts-ignore
import { UploadDisbursementDocument200Response } from '../model';
// @ts-ignore
import { UploadDisbursementRequirementRequest } from '../model';
/**
 * BNPLApi - axios parameter creator
 * @export
 */
export const BNPLApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This API is for canceling the order in the dashboard for MP
         * @summary Cancel order
         * @param {string} orderId The id of an order
         * @param {CancelOrderDashboardRequest} cancelOrderDashboardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrderDashboard: async (orderId: string, cancelOrderDashboardRequest: CancelOrderDashboardRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('cancelOrderDashboard', 'orderId', orderId)
            // verify required parameter 'cancelOrderDashboardRequest' is not null or undefined
            assertParamExists('cancelOrderDashboard', 'cancelOrderDashboardRequest', cancelOrderDashboardRequest)
            const localVarPath = `/v1/bnpl-consumer/orders/{order_id}/cancel`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = cancelOrderDashboardRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns general order detail
         * @summary Get general order detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralOrderDetail: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/bnpl/orders/{order_id}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns order detail in the dashboard for MP
         * @summary Get order detail for MP
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDetailForMPDashboard: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/bnpl-consumer/orders/{order_id}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns list of requirement documents
         * @summary Get order\'s requirement documents for BNPL consumer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderRequirementDocConsumer: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/bnpl-consumer/orders/{order_id}/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns list of requirement documents
         * @summary Get order\'s requirement documents for BNPL provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderRequirementDocProvider: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/bnpl-provider/orders/{order_id}/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns list of orders in the dashboard for MP
         * @summary Get orders list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {Array<OrderStatusType>} [statuses] 
         * @param {string} [keyword] 
         * @param {BnplOrderSortType} [sortBy] 
         * @param {SortOrderType} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersList: async (page?: number, limit?: number, statuses?: Array<OrderStatusType>, keyword?: string, sortBy?: BnplOrderSortType, sortOrder?: SortOrderType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/bnpl-consumer/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This API is for uploading disbursement requirement document in the dashboard for MP
         * @summary Upload disbursement requirement
         * @param {UploadDisbursementRequirementRequest} uploadDisbursementRequirementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDisbursementDocument: async (uploadDisbursementRequirementRequest: UploadDisbursementRequirementRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadDisbursementRequirementRequest' is not null or undefined
            assertParamExists('uploadDisbursementDocument', 'uploadDisbursementRequirementRequest', uploadDisbursementRequirementRequest)
            const localVarPath = `/v1/bnpl-consumer/orders/{order_id}/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = uploadDisbursementRequirementRequest

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BNPLApi - functional programming interface
 * @export
 */
export const BNPLApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BNPLApiAxiosParamCreator(configuration)
    return {
        /**
         * This API is for canceling the order in the dashboard for MP
         * @summary Cancel order
         * @param {string} orderId The id of an order
         * @param {CancelOrderDashboardRequest} cancelOrderDashboardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrderDashboard(orderId: string, cancelOrderDashboardRequest: CancelOrderDashboardRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISuccessEmpty>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrderDashboard(orderId, cancelOrderDashboardRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns general order detail
         * @summary Get general order detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeneralOrderDetail(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGeneralOrderDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneralOrderDetail(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns order detail in the dashboard for MP
         * @summary Get order detail for MP
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderDetailForMPDashboard(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderDetailForMPDashboard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderDetailForMPDashboard(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns list of requirement documents
         * @summary Get order\'s requirement documents for BNPL consumer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderRequirementDocConsumer(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderRequirementDocConsumer200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderRequirementDocConsumer(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns list of requirement documents
         * @summary Get order\'s requirement documents for BNPL provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderRequirementDocProvider(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderRequirementDocConsumer200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderRequirementDocProvider(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns list of orders in the dashboard for MP
         * @summary Get orders list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {Array<OrderStatusType>} [statuses] 
         * @param {string} [keyword] 
         * @param {BnplOrderSortType} [sortBy] 
         * @param {SortOrderType} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrdersList(page?: number, limit?: number, statuses?: Array<OrderStatusType>, keyword?: string, sortBy?: BnplOrderSortType, sortOrder?: SortOrderType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrdersList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrdersList(page, limit, statuses, keyword, sortBy, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This API is for uploading disbursement requirement document in the dashboard for MP
         * @summary Upload disbursement requirement
         * @param {UploadDisbursementRequirementRequest} uploadDisbursementRequirementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDisbursementDocument(uploadDisbursementRequirementRequest: UploadDisbursementRequirementRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadDisbursementDocument200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDisbursementDocument(uploadDisbursementRequirementRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BNPLApi - factory interface
 * @export
 */
export const BNPLApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BNPLApiFp(configuration)
    return {
        /**
         * This API is for canceling the order in the dashboard for MP
         * @summary Cancel order
         * @param {string} orderId The id of an order
         * @param {CancelOrderDashboardRequest} cancelOrderDashboardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrderDashboard(orderId: string, cancelOrderDashboardRequest: CancelOrderDashboardRequest, options?: any): AxiosPromise<APISuccessEmpty> {
            return localVarFp.cancelOrderDashboard(orderId, cancelOrderDashboardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns general order detail
         * @summary Get general order detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeneralOrderDetail(options?: any): AxiosPromise<GetGeneralOrderDetail200Response> {
            return localVarFp.getGeneralOrderDetail(options).then((request) => request(axios, basePath));
        },
        /**
         * This returns order detail in the dashboard for MP
         * @summary Get order detail for MP
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDetailForMPDashboard(options?: any): AxiosPromise<GetOrderDetailForMPDashboard200Response> {
            return localVarFp.getOrderDetailForMPDashboard(options).then((request) => request(axios, basePath));
        },
        /**
         * This returns list of requirement documents
         * @summary Get order\'s requirement documents for BNPL consumer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderRequirementDocConsumer(options?: any): AxiosPromise<GetOrderRequirementDocConsumer200Response> {
            return localVarFp.getOrderRequirementDocConsumer(options).then((request) => request(axios, basePath));
        },
        /**
         * This returns list of requirement documents
         * @summary Get order\'s requirement documents for BNPL provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderRequirementDocProvider(options?: any): AxiosPromise<GetOrderRequirementDocConsumer200Response> {
            return localVarFp.getOrderRequirementDocProvider(options).then((request) => request(axios, basePath));
        },
        /**
         * This returns list of orders in the dashboard for MP
         * @summary Get orders list
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {Array<OrderStatusType>} [statuses] 
         * @param {string} [keyword] 
         * @param {BnplOrderSortType} [sortBy] 
         * @param {SortOrderType} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrdersList(page?: number, limit?: number, statuses?: Array<OrderStatusType>, keyword?: string, sortBy?: BnplOrderSortType, sortOrder?: SortOrderType, options?: any): AxiosPromise<GetOrdersList200Response> {
            return localVarFp.getOrdersList(page, limit, statuses, keyword, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * This API is for uploading disbursement requirement document in the dashboard for MP
         * @summary Upload disbursement requirement
         * @param {UploadDisbursementRequirementRequest} uploadDisbursementRequirementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDisbursementDocument(uploadDisbursementRequirementRequest: UploadDisbursementRequirementRequest, options?: any): AxiosPromise<UploadDisbursementDocument200Response> {
            return localVarFp.uploadDisbursementDocument(uploadDisbursementRequirementRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BNPLApi - interface
 * @export
 * @interface BNPLApi
 */
export interface BNPLApiInterface {
    /**
     * This API is for canceling the order in the dashboard for MP
     * @summary Cancel order
     * @param {string} orderId The id of an order
     * @param {CancelOrderDashboardRequest} cancelOrderDashboardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApiInterface
     */
    cancelOrderDashboard(orderId: string, cancelOrderDashboardRequest: CancelOrderDashboardRequest, options?: AxiosRequestConfig): AxiosPromise<APISuccessEmpty>;

    /**
     * This returns general order detail
     * @summary Get general order detail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApiInterface
     */
    getGeneralOrderDetail(options?: AxiosRequestConfig): AxiosPromise<GetGeneralOrderDetail200Response>;

    /**
     * This returns order detail in the dashboard for MP
     * @summary Get order detail for MP
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApiInterface
     */
    getOrderDetailForMPDashboard(options?: AxiosRequestConfig): AxiosPromise<GetOrderDetailForMPDashboard200Response>;

    /**
     * This returns list of requirement documents
     * @summary Get order\'s requirement documents for BNPL consumer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApiInterface
     */
    getOrderRequirementDocConsumer(options?: AxiosRequestConfig): AxiosPromise<GetOrderRequirementDocConsumer200Response>;

    /**
     * This returns list of requirement documents
     * @summary Get order\'s requirement documents for BNPL provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApiInterface
     */
    getOrderRequirementDocProvider(options?: AxiosRequestConfig): AxiosPromise<GetOrderRequirementDocConsumer200Response>;

    /**
     * This returns list of orders in the dashboard for MP
     * @summary Get orders list
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {Array<OrderStatusType>} [statuses] 
     * @param {string} [keyword] 
     * @param {BnplOrderSortType} [sortBy] 
     * @param {SortOrderType} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApiInterface
     */
    getOrdersList(page?: number, limit?: number, statuses?: Array<OrderStatusType>, keyword?: string, sortBy?: BnplOrderSortType, sortOrder?: SortOrderType, options?: AxiosRequestConfig): AxiosPromise<GetOrdersList200Response>;

    /**
     * This API is for uploading disbursement requirement document in the dashboard for MP
     * @summary Upload disbursement requirement
     * @param {UploadDisbursementRequirementRequest} uploadDisbursementRequirementRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApiInterface
     */
    uploadDisbursementDocument(uploadDisbursementRequirementRequest: UploadDisbursementRequirementRequest, options?: AxiosRequestConfig): AxiosPromise<UploadDisbursementDocument200Response>;

}

/**
 * BNPLApi - object-oriented interface
 * @export
 * @class BNPLApi
 * @extends {BaseAPI}
 */
export class BNPLApi extends BaseAPI implements BNPLApiInterface {
    /**
     * This API is for canceling the order in the dashboard for MP
     * @summary Cancel order
     * @param {string} orderId The id of an order
     * @param {CancelOrderDashboardRequest} cancelOrderDashboardRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApi
     */
    public cancelOrderDashboard(orderId: string, cancelOrderDashboardRequest: CancelOrderDashboardRequest, options?: AxiosRequestConfig) {
        return BNPLApiFp(this.configuration).cancelOrderDashboard(orderId, cancelOrderDashboardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns general order detail
     * @summary Get general order detail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApi
     */
    public getGeneralOrderDetail(options?: AxiosRequestConfig) {
        return BNPLApiFp(this.configuration).getGeneralOrderDetail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns order detail in the dashboard for MP
     * @summary Get order detail for MP
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApi
     */
    public getOrderDetailForMPDashboard(options?: AxiosRequestConfig) {
        return BNPLApiFp(this.configuration).getOrderDetailForMPDashboard(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns list of requirement documents
     * @summary Get order\'s requirement documents for BNPL consumer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApi
     */
    public getOrderRequirementDocConsumer(options?: AxiosRequestConfig) {
        return BNPLApiFp(this.configuration).getOrderRequirementDocConsumer(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns list of requirement documents
     * @summary Get order\'s requirement documents for BNPL provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApi
     */
    public getOrderRequirementDocProvider(options?: AxiosRequestConfig) {
        return BNPLApiFp(this.configuration).getOrderRequirementDocProvider(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns list of orders in the dashboard for MP
     * @summary Get orders list
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {Array<OrderStatusType>} [statuses] 
     * @param {string} [keyword] 
     * @param {BnplOrderSortType} [sortBy] 
     * @param {SortOrderType} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApi
     */
    public getOrdersList(page?: number, limit?: number, statuses?: Array<OrderStatusType>, keyword?: string, sortBy?: BnplOrderSortType, sortOrder?: SortOrderType, options?: AxiosRequestConfig) {
        return BNPLApiFp(this.configuration).getOrdersList(page, limit, statuses, keyword, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This API is for uploading disbursement requirement document in the dashboard for MP
     * @summary Upload disbursement requirement
     * @param {UploadDisbursementRequirementRequest} uploadDisbursementRequirementRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BNPLApi
     */
    public uploadDisbursementDocument(uploadDisbursementRequirementRequest: UploadDisbursementRequirementRequest, options?: AxiosRequestConfig) {
        return BNPLApiFp(this.configuration).uploadDisbursementDocument(uploadDisbursementRequirementRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
